var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrashIcon = function SvgTrashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.563 4.941a.94.94 0 0 1 .828-.935L11.5 4a.94.94 0 0 1 .938.941v.941h5.624a.94.94 0 0 1 .938.942.94.94 0 0 1-.828.934l-.11.007-.937-.001v10.354a1.88 1.88 0 0 1-1.729 1.876L15.25 20h-7.5a1.879 1.879 0 0 1-1.875-1.882V7.764h-.938A.94.94 0 0 1 4 6.825a.94.94 0 0 1 .828-.935l.11-.007h5.625v-.94Zm4.687 2.824h-7.5v10.353h7.5V7.765Z"
  })));
};
export default SvgTrashIcon;